import loadable from '@loadable/component';

// 懒加载组件
const InvoiceManagement = loadable(() => import('./invoiceManagement/InvoiceManagement'));

export const subRoutes = [
  {
    // M258008 【2308】供应商：供应商发票管理
    path: '/InvoiceManagement',
    component: InvoiceManagement
  }
];
